import { operatorsWithPartialInput } from '../api';
import { ColumnFormat } from '../table/constants/defaultColumnsWidth';
const formatters = new Map();
const phoneNumberFormatter = {
    format(value) {
        if (!value || typeof value !== 'string')
            return value ?? '';
        const match = value.replace(/[^0-9]/g, '').match(/^00(\d{3})(\d{3})(\d{3})(\d{3})$/);
        return match ? `+${match[1]} ${match[2]} ${match[3]} ${match[4]}` : value;
    },
    parse(value) {
        if (!value || typeof value !== 'string')
            return null;
        let digitsOnly = value.replace(/^\+/, '00').replace(/[^0-9]/g, '');
        if (digitsOnly.length === 9) {
            digitsOnly = '00420' + digitsOnly;
        }
        if (/^00[0-9]{11,15}$/.test(digitsOnly))
            return digitsOnly;
        // Partial input: return normalized form (e.g. +420 123 → 00420123)
        if (digitsOnly.length > 0 && /^00?[0-9]*$/.test(digitsOnly)) {
            return digitsOnly.startsWith('00') ? digitsOnly : '00' + digitsOnly;
        }
        return null;
    },
    parsePartial(value) {
        if (!value || typeof value !== 'string')
            return '';
        const digits = value.replace(/^\+/, '00').replace(/[^0-9]/g, '');
        return digits;
    },
    formatPartial(value) {
        if (!value || typeof value !== 'string')
            return value ?? '';
        const digits = value.replace(/[^0-9]/g, '');
        return digits.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    },
};
formatters.set(ColumnFormat.PHONE_NUMBER, phoneNumberFormatter);
const durationFormatter = {
    format(value) {
        const raw = String(value ?? '').trim();
        if (raw === '')
            return '';
        const seconds = Number(raw);
        if (!Number.isFinite(seconds))
            return raw;
        const safeSeconds = Math.max(0, Math.floor(seconds));
        const mm = Math.floor(safeSeconds / 60);
        const ss = safeSeconds % 60;
        return `${mm}:${String(ss).padStart(2, '0')}`;
    },
    parse(value) {
        const raw = String(value ?? '').trim();
        if (raw === '')
            return null;
        // Accept either plain seconds ("65") or mm:ss ("1:05")
        const mmss = raw.match(/^(\d+)\s*:\s*([0-5]?\d)$/);
        if (mmss) {
            const mm = Number(mmss[1]);
            const ss = Number(mmss[2]);
            if (!Number.isFinite(mm) || !Number.isFinite(ss))
                return null;
            return String(mm * 60 + ss);
        }
        if (/^\d+$/.test(raw)) {
            return raw;
        }
        return null;
    },
    parsePartial(value) {
        const raw = String(value ?? '');
        return raw.replace(/[^0-9]/g, '');
    },
};
formatters.set('DURATION', durationFormatter);
export function registerFormatter(format, formatter) {
    formatters.set(format, formatter);
}
export function getFormatter(format) {
    return format ? formatters.get(format) : undefined;
}
const FULL_PHONE_REGEX = /^00[0-9]{11,15}$/;
export function formatValue(value, columnFormat) {
    if (value == null)
        return '';
    const formatter = getFormatter(columnFormat);
    if (!formatter)
        return String(value);
    const str = String(value).replace(/[^0-9]/g, '');
    const formatted = formatter.format(String(value));
    if (formatted !== String(value))
        return formatted;
    if (formatter.formatPartial && str && !FULL_PHONE_REGEX.test(str)) {
        return formatter.formatPartial(str);
    }
    return formatted;
}
export function parseValue(value, columnFormat, operator) {
    const formatter = getFormatter(columnFormat);
    if (!formatter)
        return value;
    if (operatorsWithPartialInput.includes(operator)) {
        return formatter.parsePartial(value) || value;
    }
    return formatter.parse(value);
}
export function formatValueForDisplay(value, columnFormat, isPartial = false) {
    if (value == null)
        return '';
    const formatter = getFormatter(columnFormat);
    if (!formatter)
        return String(value);
    if (isPartial && formatter.formatPartial) {
        return formatter.formatPartial(String(value));
    }
    return formatter.format(String(value));
}
//# sourceMappingURL=valueFormatters.js.map